"use client";

import React from "react";
import SearchOutline from "@sendsprint/icons/svgs/SearchOutline";
import useSearchBlogs from "../../../hooks/useSearchBlogs";
import Box from "@sendsprint/ui-react/components/box";
import Icon from "@sendsprint/ui-react/components/icon";
import SearchInput from "@/components/searchInput";

const SearchBlogs = () => {
  const { handleChange, search } = useSearchBlogs();

  return (
    <Box className="ss:w-full ss:relative ss:xl:max-w-75 ss:mb-5 ss:md:mb-0">
      <SearchInput
        handleChange={handleChange}
        value={search}
        placeholder="Search Blogs..."
      />
    </Box>
    // <Box className="ss:w-full ss:relative ss:xl:max-w-75 ss:mb-5 ss:md:mb-0">
    //   <Icon
    //     className="ss:absolute ss:top-2/4 ss:transform ss:-translate-y-2/4 ss:left-2"
    //     svg={SearchOutline}
    //     size={20}
    //   />
    //   <input
    //     type="search"
    //     value={search}
    //     placeholder="Search Blogs"
    //     onChange={handleChange}
    //     className="ss:border ss:block focus:ss:focus-ring ss:bg-neutral-100 ss:placeholder-neutral-400 ss:text-neutral-500 ss:border-neutral-300 ss:hover-border-primary1-500 focus:ss:border-primary1-50 ss:text-paragraph-regular ss:py-3 ss:px-4 ss:pr-5 ss:pl-10 ss:rounded-base  ss:text-body ss:w-full ss:h-10 ss:border-neutral-20"
    //   />
    // </Box>
  );
};

export default SearchBlogs;
